import { Badge, Button, Popconfirm, Space, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

import type { ColumnsType } from 'antd/lib/table';
import { ProducerDTO } from '../../types/data/producer-management.type';

export const getProducerColumns = (
  handleEdit: (producer: ProducerDTO) => void,
  handleDelete: (producerId: string) => void,
  disabled?: boolean
): ColumnsType<ProducerDTO> => [
  {
    title: 'Producer Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (text: string, record: ProducerDTO) => (
      <div
        style={{
          fontWeight: record.isProducerActiveForEApp ? 'bold' : 'normal'
        }}>
        {text}
        {record.isProducerActiveForEApp && (
          <Badge
            count='ACTIVE'
            style={{
              backgroundColor: '#52c41a',
              marginLeft: 8,
              fontSize: '10px'
            }}
          />
        )}
      </div>
    )
  },
  {
    title: 'NPN Number',
    dataIndex: 'npnNumber',
    key: 'npnNumber',
    sorter: (a, b) => a.npnNumber.localeCompare(b.npnNumber)
  },
  {
    title: 'Status',
    dataIndex: 'isProducerActiveForEApp',
    key: 'status',
    render: (isActive: boolean) => (
      <Tooltip title='Active producer is used for E-App submissions'>
        <Badge
          status={isActive ? 'success' : 'default'}
          text={isActive ? 'Active' : 'Inactive'}
        />
      </Tooltip>
    ),
    filters: [
      { text: 'Active', value: true },
      { text: 'Inactive', value: false }
    ],
    onFilter: (value, record) => record.isProducerActiveForEApp === value
  },
  {
    title: 'Carriers Contracted',
    dataIndex: 'carrierMappings',
    key: 'carrierMappings',
    render: (mappings: any[]) => (
      <span>
        {mappings?.length || 0} carrier{mappings?.length !== 1 ? 's' : ''}
      </span>
    )
  },
  {
    title: 'Actions',
    key: 'actions',
    fixed: 'right',
    width: 120,
    render: (_, record: ProducerDTO) => (
      <Space size='small'>
        <Tooltip title='Edit Producer'>
          <Button
            type='primary'
            icon={<EditOutlined />}
            size='small'
            onClick={() => handleEdit(record)}
            disabled={disabled}
          />
        </Tooltip>
        <Tooltip title='Delete Producer'>
          <Popconfirm
            title='Delete Producer'
            description={`Are you sure you want to delete "${record.name}"? This action cannot be undone.`}
            onConfirm={() => handleDelete(record.id)}
            okText='Yes, Delete'
            cancelText='Cancel'
            okType='danger'
            disabled={disabled}>
            <Button
              type='primary'
              danger
              icon={<DeleteOutlined />}
              size='small'
              disabled={disabled}
            />
          </Popconfirm>
        </Tooltip>
      </Space>
    )
  }
];
